import { render } from "./SearchBox.vue?vue&type=template&id=564b01b2&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=564b01b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564b01b2"]])

export default __exports__